<app-navbar title="Kwaterunek - generowanie">
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<div class="container">
	<form class="my-4" (submit)="submit()">
		<div class="form-floating mb-3">
			<input type="date" class="form-control" id="forDate" name="control" [(ngModel)]="forDate" />
			<label for="forDate">Dla daty</label>
		</div>
		<div class="mb-3">
			<button type="submit" class="btn btn-primary">Ubezpieczenie od Kosztów Leczenie</button>
		</div>
	</form>
</div>
<hr />
<div class="container">
	<p>
		Plik z listą ubezpieczniową <br />
		<i class="fas fa-external-link-alt icon"></i>
		<a
			href="https://docs.google.com/spreadsheets/d/1B3i4JaXL-OtT7Uf8MlLPeacNVxxO2q3ZeQSGZfYyJbo/edit#gid=0"
			target="_blank"
			>https://docs.google.com/spreadsheets/d/1B3i4JaXL-OtT7Uf8MlLPeacNVxxO2q3ZeQSGZfYyJbo/edit#gid=0</a
		>
	</p>
</div>
